import React from 'react';

import Reveal from '../ui/Reveal';

const stages = [
    {
        tag: 'AC meter',
        title: 'Utility incomer',
        text: 'What the utility is delivering, before anything of ours touches it.'
    },
    {
        tag: 'AC meter',
        title: 'UPS rectifier input',
        text: 'What actually reaches the UPS, and how the rectifier loads the supply.'
    },
    {
        tag: 'DC bus',
        title: '800 VDC link',
        text: 'The rectifier, the battery and the inverter sections all meet here. Measured for voltage, ripple, current, heat and insulation.',
        link: true
    },
    {
        tag: 'AC meter',
        title: 'UPS inverter output',
        text: 'What the UPS is producing for the load, whatever the supply is doing upstream.'
    },
    {
        tag: 'AC meter',
        title: 'PDU / rack feed',
        text: 'What finally reaches the racks. This is the reading the servers live with.'
    }
];

/**
 * One UPS path, drawn as the chain the power travels. Built from a list
 * rather than an image: the labels stay real text for a reader or a crawler,
 * and on a phone the row simply becomes a column.
 */
export default function PowerPath() {
    return (
        <Reveal className="path" y={24}>
            <div className="path__bypass">
                <div className="path__box path__box--side">
                    <span className="path__tag">AC meter</span>
                    <h3 className="path__title">Static bypass</h3>
                    <p className="path__copy">Energized and unloaded in normal operation. It is measured anyway, because it is the way around the UPS.</p>
                </div>
            </div>

            <ol className="path__chain">
                {stages.map(stage => (
                    <li className={`path__box${stage.link ? ' path__box--link' : ''}`} key={stage.title}>
                        <span className="path__tag">{stage.tag}</span>
                        <h3 className="path__title">{stage.title}</h3>
                        <p className="path__copy">{stage.text}</p>
                    </li>
                ))}
            </ol>

            <div className="path__battery">
                <div className="path__box path__box--side">
                    <span className="path__tag">BMS</span>
                    <h3 className="path__title">Battery, through DC/DC</h3>
                    <p className="path__copy">Charge, health, cell voltages, temperatures and estimated runtime.</p>
                </div>
            </div>
        </Reveal>
    );
}
